import { Content } from '@radix-ui/react-tooltip';
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { PropsWithClassName } from 'src/shared/utils/types/PropsWithClassName';

import { cn } from '@shared/utils/helpers';

import { TooltipContentProps } from './Tooltip.types';

export function TooltipContent({
  className,
  sideOffset = 4,
  children,
  ...props
}: PropsWithChildren<PropsWithClassName<TooltipContentProps>>) {
  return (
    <Content
      sideOffset={sideOffset}
      className={cn(
        'z-50 overflow-hidden rounded-md border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-950 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    >
      {children}
    </Content>
  );
}
